import React from 'react';

import { useStaffAccess } from './StaffRoute';

/**
 * Renders children only for internal staff. Unlike StaffRoute this is not a
 * route -- it wraps a page already mounted inside an app shell, so the
 * surrounding header and sidebar stay put while the gate resolves.
 */
export default function StaffOnly({ children }) {
  const isStaff = useStaffAccess();

  if (isStaff === null) {
    return (
      <div style={{ padding: 80, textAlign: 'center', color: '#737C8C', fontSize: 14 }}>
        Checking access…
      </div>
    );
  }

  if (!isStaff) {
    return (
      <div style={{ padding: '80px 24px', textAlign: 'center' }}>
        <p style={{ fontSize: 20, fontWeight: 800, color: '#0B0D12', margin: '0 0 8px' }}>
          Staff access only
        </p>
        <p style={{ fontSize: 14, color: '#737C8C', margin: 0 }}>
          This page is for the internal team. Ask an admin to mark your account as staff.
        </p>
      </div>
    );
  }

  return children;
}
